import { observer } from 'mobx-react';
import React from 'react';
import { VALIDITY_PERIOD } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { capitalLetter } from 'src/utils/formatter';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import { cashbackStore } from 'src/view/screens/MarketingScreen/screens/Cashback/store/cashbackStore';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from '~/view/components/Text/Text';
import Input from '~/view/components/Controls/InputComponent/Input';
import './style.scss';

enum INPUT_NAME {
  CASHBACK = 'cashback',
}

@observer
export default class CashbackBalance extends React.Component<{}, {}> {
  changeData = (key: string | number) => {
    cashbackStore.changeCashback({
      validity: String(key),
    });
  };

  onChange = (value: string | undefined) => {
    cashbackStore.changeCashback({ validity_period: value });
  };

  get balanceOptions(): IPickerOption[] {
    return [
      { value: VALIDITY_PERIOD.DAYS, label: capitalLetter(localeStore.t('d')) },
      { value: VALIDITY_PERIOD.WEEKS, label: VALIDITY_PERIOD.WEEKS },
      { value: VALIDITY_PERIOD.MONTHS, label: VALIDITY_PERIOD.MONTHS },
      { value: VALIDITY_PERIOD.FOREVER, label: VALIDITY_PERIOD.FOREVER },
    ];
  }

  render() {
    return (
      <div className="mt-6">
        <Text
          text={localeStore.t('balance_validity_period')}
          type={TEXT.BLOCK_HEADER}
          tooltip={{ message: 'cashback_balance_validity_hint', position: TOOLTIP_POSITION.PORTAL }}
          required
        />
        <div className="d-flex mt-3">
          <TabPicker
            value={cashbackStore.cashback.validity ? cashbackStore.cashback.validity : VALIDITY_PERIOD.DAYS}
            options={this.balanceOptions}
            onChange={this.changeData}
            className="mr-3"
          />
          {cashbackStore.cashback.validity !== VALIDITY_PERIOD.FOREVER ? (
            <Input
              name={INPUT_NAME.CASHBACK}
              type="number"
              value={cashbackStore.cashback.validity_period || '0'}
              onChangeValue={this.onChange}
              contentClassName="cashback__input input-number family-semibold text-size-18"
              inputClassName="text-center family-semibold text-size-18"
              validation={{
                isValid: cashbackStore.validationErrors.balanceValidityPeriod === null,
                errorText: cashbackStore.validationErrors.balanceValidityPeriod || '',
              }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
